import React from 'react';
import { ColumnType } from 'antd/lib/table/interface';
import { t } from 'i18next';

import IbTable from '../../../../../../components/common/IbTable';

export interface StatusItem {
  id: number;
  code: string;
  name: string;
  isSelected: boolean;
}

export interface ELMA365AppStatusSelectorProps {
  items: StatusItem[];
  loading?: boolean;
  onChange?: (selectedItemIds: number[]) => void;
}

const ELMA365AppStatusSelector: React.FC<ELMA365AppStatusSelectorProps> = ({ items, loading, onChange }) => {
  const columns: ColumnType<StatusItem>[] = [
    {
      title: t('Source settings: ELMA365: Status: Item: ID'),
      dataIndex: 'id',
      key: 'id',
      render: (_, record) => record.id,
    },
    {
      title: t('Source settings: ELMA365: Status: Item: Code'),
      dataIndex: 'code',
      key: 'code',
      render: (_, record) => record.code,
      width: '50%',
    },
    {
      title: t('Source settings: ELMA365: Status: Item: Name'),
      dataIndex: 'name',
      key: 'name',
      render: (_, record) => record.name,
      width: '50%',
    },
  ];

  const selectedRowKeys = items.filter((i) => i.isSelected).map((f) => f.id);

  const handleSelectedRowKeysChange = (newKeys: React.Key[]) => {
    onChange?.(newKeys as number[]);
  };

  return (
    <IbTable
      columns={columns}
      dataSource={items}
      loading={loading}
      rowKey="id"
      selectedRowKeys={selectedRowKeys}
      size="middle"
      onSelectedRowKeysChange={handleSelectedRowKeysChange}
    />
  );
};

export default ELMA365AppStatusSelector;
